import { css } from "@emotion/css";
import { Button, Menu, MenuItem } from "@material-ui/core";
import React from "react";
import { BiLogOut, BiUser } from "react-icons/bi";
import { useAuth } from "./state/state/authStore";
import {
  createAnonymousAccount,
  linkToGoogle,
  loginToGoogle,
  logout,
} from "./state/state/firebase";

export function Auth() {
  const auth = useAuth();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCreateAnonymous = () => {
    createAnonymousAccount();
    handleClose();
  };

  const associateToGoogle = () => {
    handleClose();
    linkToGoogle();
  };

  const handleLoginToGoogle = () => {
    handleClose();
    loginToGoogle();
  };

  const handleLogout = () => {
    handleClose();
    logout();
  };

  return (
    <div>
      <BiLogOut
        className={css`
          font-size: 2em;
          cursor: pointer;
        `}
        title="Logout"
        onClick={() => handleLogout()}
      />
    </div>
  );
}

function MenuComp({ handleClick, anchorEl, handleClose, label, children }) {
  return (
    <>
      {" "}
      <button
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        {label}
      </button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {children}
      </Menu>
    </>
  );
}
